import React, { useState, useEffect, useRef} from "react";
import './DisplaySelect.scss';
import {ReactComponent as IconArrowUp} from '../../assets/icons/ic-arrow-up.svg'
import {ReactComponent as IconArrowDown} from '../../assets/icons/ic-arrow-down.svg'
import {ReactComponent as IconCheck} from '../../assets/icons/ic-check_blue.svg';

//onChange value 가져오는 로직 넣어야 됨.
//react-select로 추후 변경 예정.
function DisplaySelect({options,selectType,value,index,list,handleChangeSelect, style = ''}) {
    const selectRef = useRef();
    const [optionList, setOptionList] = useState([])
    const [nowOption, setNowOption] = useState()
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)
    const DropDownIndex = [0,1,2,6,7,8]

    const handleClickOutside = (event) => {
        if (selectRef.current && !selectRef.current.contains(event.target)) {
            setIsDropdownOpen(false);
        }
    };

    // 중복 검사에 사용
    useEffect(() => {                
        const codeSet = new Set(list.map(item => item.measureParameterId));
        const codeList = options.filter(item => {
            if(value === item.id){
                setNowOption(item.parameter);
            }           
            return item.parameter === "NONE" || value === item.id || !codeSet.has(item.id);            
        })
        .sort((a, b) => a.parameter.localeCompare(b.parameter));        
        setOptionList(codeList);
    }, [list])

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (             
        <div className={`relative h-[26px] ${selectType == 'Wave' ? 'w-[138px]' : 'w-[90px]'}`} ref={selectRef}>
            <div className="bg-gradient-to-b from-[#5E5E5E] to-[#383838] text-[#DEDEDE] h-[26px] px-[8px] rounded-[6px] cursor-pointer flex items-center justify-between border border-[#4E4E4E]" onClick={(e) => { e.stopPropagation(); setIsDropdownOpen((prev) => !prev);}}>                                
                <div className="w-[200px]">{nowOption}</div>
            </div>

            {
                isDropdownOpen && (
                    <div className={`${selectType == 'Wave' ? 'w-[138px]' : 'w-[90px]'} custom-select ${DropDownIndex.includes(index) ? 'top-[30px]' : 'bottom-[30px]'} absolute h-[200px] overflow-y-auto over bg-[#1F1F1F] w-[130px] py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] z-20`} onClick={(e) => { e.stopPropagation(); setIsDropdownOpen((prev) => !prev);}}>
                        {
                            optionList && optionList.map((option,_) => (
                                <div key={option.id} className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] ${option.id === value ? "text-[#3182F7]" : "text-white"}`} onClick={(e) => { e.stopPropagation(); handleChangeSelect(selectType,index,option.id,option.parameter); (option.id === value && setIsDropdownOpen((prev) => !prev))}}>
                                    {option.parameter}   
                                    {option.id === value && (
                                        <IconCheck className="w-4 h-4 ml-2" />
                                    )}                                 
                                </div>
                            ))
                        }
                    </div>
                )
            }
            <div className="absolute transform -translate-y-1/2 pointer-events-none top-1/2 right-2">
                {isDropdownOpen ?  <IconArrowUp/> : <IconArrowDown/>}
            </div>
        </div>

    );
}

export default DisplaySelect;
